module.exports = __webpack_public_path__ + "static/img/s126.1adecdc5.png";